export const translations = {
	en: {
		// Header
		appTitle: "MY SURVEY PORTAL",
		surveyId: "ID",

		refresh: "Refresh",
		
		// Tabs
		tabPreview: "Preview",
		tabLinkManager: "Link Manager",
		tabQuotas: "Quotas",
		tabDataViz: "Single Variables",
		tabData: "Data",
		tabChatbot: "Survey Chatbot",
		tabPerformanceMetrics: "Performance Metrics",
		tabAdHocDataViz: "Ad Hoc Dataviz",
		// Messages
		noFeaturesAvailable: "No features available with your current permissions and/or interface configuration. If something is not like it is supposed to be, please contact your administrator",
		
		// Errors
		error404: "This is not what you are looking for",
		error401: "You are not authorized to access this interface.\nPlease contact your administrator",
		error500: "Unexpected error happened",
		error422: "Unexpected data structure",
		
		// Common
		loading: "Loading...",
		loadingApp: "Chargement du portail d'enquête...",

		previewTitle : "Notes",
		previewText : "This is a preview of your survey. No data will be collected or saved when you interact with the preview. Use this to test the survey flow and appearance before sharing with respondents.",
	
		linkStatsTitle: "Link Statistics",
		linkGeneratorTitle: "Link generator",
		generateNewLinks: "Generate New Links",
		numerOfLinks: "Number of Links (1-2500)",
		tags: "Tags",
		generateButton: "Generate & Download Links",
		linkGenratorText: "Links will be generated and automatically downloaded as a csv file. Each link is unique and can be used once.",
		linkByGroup: "Links by groups",

		quotasTitle: "Quota Tracking",
		quotasSingleStatsTarget: "Total Target",
		quotasSingleStatsCurrent: "Total Current",
		quotasSingleStatsFilled: "Fulfilled Quotas",
		quotasSingleStatsOverallProgress: "Overall Progress",
		quotasSingleStatsFullfillmentRate: "Fulfillment Rate",

		surveyPerformanceTitle: "Survey Performance Tracking",

		topLineTitle: "Topline",

		adHocViztitle: "Ad-Hoc Dashboard",
		adHocsubtitle: "Powered by Apache Superset",
		adHocdescription1: "This feature brings powerful, customizable data visualization capabilities directly into your application through Apache Superset integration. Build interactive dashboards, explore data visually, and gain deeper insights into your survey results.",
		adHocdescription2: "Once configured, your Superset dashboards will appear directly inside this application — no need to switch tools.",
		adHocfeaturesTitle: "Available Features",
		adHocfeature1: "Custom interactive dashboards for survey metrics",
		adHocfeature2: "Advanced data exploration and filtering",
		adHocfeature3: "Real-time data synchronization",
		adHocfeature4: "Export and sharing capabilities",
		adHocsetupTitle: "Setup Required",
		adHocsetupDescription: "Contact us to configure Superset and enable ad-hoc data visualizations tailored to your surveys.",
		adHoccontactButton: "Contact admin",

		// Add to Tabs section
		tabResources: "Resources",

		// Add to Common or create a Resources section
		resourcesTitle: "Resources & Documentation",
		noResources: "No resources available for this interface.",
		
		// Resource Card
		resourceUrl: "URL",
		resourceCredentials: "Credentials",
		resourceOpenLink: "Open Link",
		resourceCopy: "Copy",
		resourceCopied: "Copied!",
		resourceShow: "Show",
		resourceHide: "Hide",

	},
	fr: {
		// Header
		appTitle: "MON PORTAIL D'ÉTUDE",
		surveyId: "ID",
		refresh: "Rafraichir",
		
		// Tabs
		tabPreview: "Aperçu",
		tabLinkManager: "Gestionnaire de liens",
		tabQuotas: "Quotas",
		tabDataViz: "Tri à plat",
		tabData: "Données",
		tabChatbot: "Chatbot d'enquête",
		tabPerformanceMetrics: "Metriques Performance",
		tabAdHocDataViz: "Ad Hoc Dataviz",
		
		// Messages
		noFeaturesAvailable: "Aucune fonctionnalité disponible avec vos permissions actuelles et/ou configuration d'interface. Si quelque chose ne fonctionne pas comme prévu, veuillez contacter votre administrateur",
		
		// Errors
		error404: "Ce n'est pas ce que vous recherchez",
		error401: "Vous n'êtes pas autorisé à accéder à cette interface.\nVeuillez contacter votre administrateur",
		error500: "Une erreur inattendue s'est produite",
		error422: "Structure de données inattendue",
		
		// Common
		loading: "Chargement...",
		loadingApp: "Chargement du portail d'enquête...",
		previewTitle : "Notes",
		previewText : "Ceci est un aperçu de votre sondage. Aucune donnée ne sera collectée ni enregistrée lorsque vous interagirez avec l'aperçu. Utilisez-le pour tester le déroulement et l'apparence du sondage avant de le partager avec les répondants.",

		linkStatsTitle: "Statistiques sur les liens",
		linkGeneratorTitle: "Generateur de liens",
		generateNewLinks: "Generer de nouveaux liens",
		numerOfLinks: "Nombre de liens (1-2500)",
		tags: "Tags",
		generateButton: "Génerer et telecharger",
		linkGenratorText: "Les liens seront générés et téléchargés automatiquement sous forme de fichier CSV. Chaque lien est unique et peut être utilisé une seule fois.",
		linkByGroup: "Liens par groupes",

		quotasTitle: "Suivi des Quotas",

		quotasSingleStatsTarget: "Cible totale",
		quotasSingleStatsCurrent: "Total atteints",
		quotasSingleStatsFilled: "Quotas remplis",
		quotasSingleStatsOverallProgress: "Progrès global",
		quotasSingleStatsFullfillmentRate: "Taux de remplissage",

		surveyPerformanceTitle: "Performance de l'étude",

		topLineTitle: "Topline",


		adHocViztitle: "Tableaux de bord Ad-Hoc",
		adHocsubtitle: "Propulsé par Apache Superset",
		adHocdescription1: "Cette fonctionnalité apporte des capacités puissantes et personnalisables de visualisation de données directement dans votre application grâce à l'intégration d'Apache Superset. Créez des tableaux de bord interactifs, explorez vos données visuellement et obtenez des informations plus approfondies sur vos résultats d’enquête.",
		adHocdescription2: "Une fois configurés, vos tableaux de bord Superset apparaîtront directement dans cette application — sans avoir à changer d'outil.",
		adHocfeaturesTitle: "Fonctionnalités Disponibles",
		adHocfeature1: "Tableaux de bord interactifs personnalisés pour les métriques d'enquête",
		adHocfeature2: "Exploration et filtrage avancés des données",
		adHocfeature3: "Synchronisation des données en temps réel",
		adHocfeature4: "Fonctionnalités d'exportation et de partage",
		adHocsetupTitle: "Configuration Requise",
		adHocsetupDescription: "Contactez-nous pour configurer Superset et activer les visualisations de données ad-hoc adaptées à vos enquêtes.",
		adHoccontactButton: "Contacter l'administrateur",

		tabResources: "Ressources",

		// Add to Common or create a Resources section
		resourcesTitle: "Ressources & Documentation",
		noResources: "Aucune ressource disponible pour cette interface.",

		// Resource Card
		resourceUrl: "URL",
		resourceCredentials: "Identifiants",
		resourceOpenLink: "Ouvrir le lien",
		resourceCopy: "Copier",
		resourceCopied: "Copié !",
		resourceShow: "Afficher",
		resourceHide: "Masquer",
	}
};
  
export const LANGUAGES = [
	{ code: 'en', label: 'English', flag: '🇬🇧' },
	{ code: 'fr', label: 'Français', flag: '🇫🇷' }
];
